import React, { useState, useEffect } from "react";
import * as prismic from "@prismicio/client";

import { GoogleMap, useJsApiLoader, MarkerF, InfoWindowF } from "@react-google-maps/api";
import { Flex, Spinner, Heading, Text, Box } from "@chakra-ui/react";
import { PrismicRichText } from "@prismicio/react";
import styles from "./GoogleMap.module.css";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const GoogleMapComp = ({ infoWindowTitle, infoWindowDescription, googleMapsLink, geoCoordinates }) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
  });

  const [map, setMap] = useState(null);

  const [isInfoWindowOpen, setIsInfoWindowOpen] = useState(false);

  const onLoad = React.useCallback(function callback(map) {
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const onMarkerClick = () => {
    setIsInfoWindowOpen(true);
  };

  const onCloseInfoWindow = () => {
    setIsInfoWindowOpen(false);
  };

  return isLoaded ? (
    <GoogleMap mapContainerStyle={containerStyle} center={geoCoordinates} zoom={14} onLoad={onLoad} onUnmount={onUnmount}>
      {geoCoordinates && <MarkerF key="4" position={geoCoordinates} onClick={onMarkerClick} />}
      {isInfoWindowOpen && (
        <InfoWindowF position={geoCoordinates} onCloseClick={onCloseInfoWindow}>
          <Box className={styles.infoWindow}>
            <Heading textStyle="h3" as="h3" textAlign="center" fontSize="20px" marginBottom="0" letterSpacing="1px" color="brand.dark">
              {infoWindowTitle}
            </Heading>
            <br />

            <PrismicRichText field={infoWindowDescription} />

            <br />
            {googleMapsLink && (
              <a href={prismic.asLink(googleMapsLink)} target="_blank" className="linkUnderline">
                <b>Find us on google maps</b>
              </a>
            )}
          </Box>
        </InfoWindowF>
      )}
    </GoogleMap>
  ) : (
    <Flex alignItems="center" justifyContent="center">
      <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
    </Flex>
  );
};

export default React.memo(GoogleMapComp);
